/**
 * URL de l’API backend (build Vite + repli heuristique en prod).
 * Toujours appeler au moment de la requête, pas au chargement du module isolé.
 */
export function getApiBaseUrl(): string {
  if (import.meta.env.PROD) {
    const buildTimeUrl = import.meta.env.VITE_API_BASE_URL
    if (buildTimeUrl && buildTimeUrl !== 'http://localhost:8080') {
      return buildTimeUrl.replace(/\/$/, '')
    }
    const currentUrl = window.location.origin
    if (currentUrl.includes('gitxplorer-project-listgithub-web')) {
      return currentUrl.replace('gitxplorer-project-listgithub-web', 'gitxplorer-project-listgithub-api')
    }
    return 'https://gitxplorer-project-listgithub-api-leajejreqa-ew.a.run.app'
  }
  const dev = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080'
  return dev.replace(/\/$/, '')
}
